export default "__VITE_ASSET__CrjZBrId__"